import { createSelector } from 'reselect';
import { RootState } from 'data';
import { DoctorManagementState } from './types';

// ==============================
// Base Selector
// ==============================

/**
 * Base selector to access the doctorManagement slice of the Redux state.
 */
const doctorManagementSelector = (state: RootState) => state.doctorManagement;

/**
 * Generic helper to create memoized selectors for any key in doctorManagement state.
 * @param field - A valid key from DoctorManagementState.
 * @returns A memoized selector that extracts the specified field from the doctorManagement state.
 */
const createDoctorSelector = <T extends keyof DoctorManagementState>(
  field: T
): ReturnType<typeof createSelector> =>
  createSelector(
    [doctorManagementSelector],
    (doctorManagementState): DoctorManagementState[T] => doctorManagementState[field]
  );

// ==============================
// Slots & Dates Selectors
// ==============================

/**
 * Selector to get the currentDate from doctorManagement state.
 */
export const selectCurrentDate = createDoctorSelector('currentDate');

/**
 * Selector to get the selectedDate from doctorManagement state.
 */
export const selectSelectedDate = createDoctorSelector('selectedDate');
